import { Outlet, useNavigate } from "react-router-dom";
import { Alert, AlertTitle, Box, Button, Stack, Typography } from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";

import { SystemModulesEnum } from "@/auth/interfaces/system-modules.enum";
import { useAuthStore } from "@/store/auth/auth.store";
import { useUserModulesStore } from "@/store/auth";

/**
 * Guard de acceso al modulo Campañas.
 *
 * Solo permite renderizar /campanas si el usuario tiene el modulo
 * "CAMPANAS.CAMPANAS" habilitado en su perfil, o es superuser/staff en
 * Django. Mismo patron que TicketClientesModule: evita que un usuario sin
 * acceso entre por URL directa y reciba una pantalla rota con 401s.
 *
 * El modulo se asigna desde /parametrizacion/gestion-accesos -> tab Modulos.
 */
export const CampanasModule = () => {
  const navigate = useNavigate();
  const user = useAuthStore((s) => s.user) as any;
  const userModules = useUserModulesStore((s) => s.modules);

  const isSuper = !!user?.is_superuser || !!user?.is_staff;
  const tieneAccesoCampanas = [
    SystemModulesEnum.CAMPANAS_CAMPANAS,
    SystemModulesEnum.CAMPANAS_COBRANZAS,
    SystemModulesEnum.CAMPANAS_FIRMA_ADENDUM,
    SystemModulesEnum.CAMPANAS_FIDELIZACION,
  ].some((modulo) => userModules.includes(modulo));

  if (!isSuper && !tieneAccesoCampanas) {
    return (
      <Box sx={{ p: 3, maxWidth: 600, mx: "auto", mt: 6 }}>
        <Alert
          severity="warning"
          icon={<LockOutlinedIcon />}
          variant="outlined"
          sx={{ alignItems: "flex-start" }}
        >
          <AlertTitle sx={{ fontWeight: 700 }}>
            Sin acceso al modulo Campañas
          </AlertTitle>
          <Stack spacing={1.5} sx={{ mt: 1 }}>
            <Typography variant="body2" color="text.secondary">
              Tu usuario no tiene habilitado el modulo de Campañas. Si necesitas
              acceso, solicitalo a un administrador desde{" "}
              <strong>/parametrizacion/gestion-accesos</strong>.
            </Typography>
            <Box>
              <Button
                variant="contained"
                size="small"
                startIcon={<HomeOutlinedIcon />}
                onClick={() => navigate("/")}
              >
                Volver al inicio
              </Button>
            </Box>
          </Stack>
        </Alert>
      </Box>
    );
  }

  return <Outlet />;
};

export default CampanasModule;
